import React from 'react'
import {
  STYLES_BORDER_RADIUS,
  STYLES_COLOR,
  STYLES_FONT_WEIGHT,
  STYLES_PADDING
} from 'modules/styles/constants/index.cjs'
import getStyleComponentUtil from 'modules/component/utils/get-style/index.js'

/**
 * @param children
 * @param style
 * @returns {Element}
 * @constructor
 */
export function TopLeftOverlay ({
  children,
  style
}) {
  return (
    <div
      style={getStyleComponentUtil({
        backgroundColor: STYLES_COLOR.BLACK,
        fontSize: '0.65em',
        padding: STYLES_PADDING.SMALLEST,
        color: STYLES_COLOR.WHITE,
        position: 'absolute',
        left: '0',
        top: '0',
        zIndex: '1',
        borderRadius: STYLES_BORDER_RADIUS.ROUNDED,
        textTransform: 'uppercase',
        fontWeight: STYLES_FONT_WEIGHT.BOLD
      }, style)}
    >
      {children}
    </div>
  )
}
